import PropostaTerapeutica from "../";

const routes = [
    { name: "PropostaTerapeuticaList", path: "/paziente/propostaterapeutica", component: PropostaTerapeutica.PropostaTerapeuticaList, meta: { title: "PropostaTerapeutica" } },
    { name: "PropostaTerapeuticaView", path: "/paziente/propostaterapeutica/view/:id", component: PropostaTerapeutica.PropostaTerapeuticaView, meta: { title: "PropostaTerapeutica View" } },
    { name: "PropostaTerapeuticaEdit", path: "/paziente/propostaterapeutica/edit/:id", component: PropostaTerapeutica.PropostaTerapeuticaEdit, meta: { title: "PropostaTerapeutica Edit" } },
];

export default routes;
